import { Close } from '@mui/icons-material';
import { twMerge } from 'tailwind-merge';

export default function ButtonCloseModal({ onClose, className = '' }) {
	return (
		<button className={twMerge('btn-action absolute text-2xl top-4 right-4', className)} onClick={onClose}>
			<Close fontSize='inherit' sx={{ color: 'var(--bzGreen)' }} />
		</button>
	);
}
